import axios from './axios';

export type McpApiKey = {
  id: string;
  name: string;
  keyPrefix: string;
  scopes: string[];
  /** "read-only" or "docs" for keys of a built-in server. */
  builtInServer: string | null;
  endpointId: string | null;
  /** The only path the key works on, e.g. /mcp/read-only. Null for keys created before keys had a server. */
  serverPath: string | null;
  createdAt: string;
  expiresAt: string;
  lastUsedAt: string | null;
  revokedAt: string | null;
};

export type OrganizationMcpApiKey = McpApiKey & {
  userId: string;
  ownerEmail: string | null;
  ownerFirstName: string | null;
  ownerLastName: string | null;
};

export type CreatedMcpApiKey = Omit<McpApiKey, 'lastUsedAt' | 'revokedAt'> & {
  key: string;
};

/** A key belongs to one server: a built-in one or an organization endpoint. */
export type CreateMcpApiKeyRequest = {
  name: string;
  expiresInDays: number;
  builtInServer?: string;
  endpointId?: string;
};

export const getMyMcpApiKeys = async () => {
  const { data } = await axios.get<McpApiKey[]>('/api/McpApiKey/Mine');
  return data;
};

export const getOrganizationMcpApiKeys = async () => {
  const { data } = await axios.get<OrganizationMcpApiKey[]>('/api/McpApiKey/Organization');
  return data;
};

export const createMcpApiKey = async (request: CreateMcpApiKeyRequest) => {
  const { data } = await axios.post<CreatedMcpApiKey>('/api/McpApiKey/Create', request);
  return data;
};

export const revokeMcpApiKey = async (id: string) => {
  await axios.post('/api/McpApiKey/Revoke', null, { params: { id } });
};

export const rotateMcpApiKey = async (id: string) => {
  const { data } = await axios.post<CreatedMcpApiKey>('/api/McpApiKey/Rotate', null, { params: { id } });
  return data;
};
